import { ProductAddonRelModelType } from '@teinor/erp/types/company/product/productAddonRel'
import { useCallback } from 'react'
import { ButtonOrLoader } from '../../../../../../../baseComponents/Button'
import LoadingSpinner from '../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ModalComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { DeleteRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import SearchBarProduct from '../../../../../SearchBarProduct'
import { OnChangeSearchBarAddProduct } from '../../../../../SearchBarProduct/types'
import TwinForm from '../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../forms/TwinForm/types'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ProductAddonsTableAndSearchDataState, ProductAddonsTableAndSearchDataStateSetData } from '../types'
import { ProductExtendedTyLong } from '../../../../../types'
import TableWithoutVirtualListing from '../../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'


interface ModalCEPATableProps extends ModalCEPATableLogicProps {
    id: string
    url: string
}

const ModalCEPATable: React.FC<ModalCEPATableProps> = ({ id, data, url, ...logic }) => {
    const { t } = useTwinTranslation()
    const { beforeSubmit, deleteRow, onSubmitHandler, changeData, loading } = useModalCEPATableLogic({ data, ...logic })
    const columns: ColumnTableSchema<ProductExtendedTyLong & ProductAddonRelModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            width: 50,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
        },
        {
            id: 'reference',
            dataKey: 'reference',
            label: t('reference', 'Referencia'),
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + allRowData.rowIndex} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => deleteRow(allRowData.rowIndex)} />,
        }
    ]
    if (!data) {
        return <LoadingSpinner />
    }
    return (
        <TwinForm action={url} onSubmit={onSubmitHandler} beforeSubmitHandler={beforeSubmit} className='flex-auto flex flex-col'>
            <SearchBarProduct changeSelectedItems={changeData} excludeIds={data?.ids || []} id={id || ''} fieldNotIn='Product.id' name='ProductAddonId' url='/api/app/product/getAllProducts' where={{}} />
            <div className='flex-auto table_container mt-20'>
                <TableWithoutVirtualListing data={data?.data || []} columns={columns} disableScroll={true} />
            </div>
            <input type='hidden' value={id} name='ProductId' />
            <div className='flex justify-end'>
                {data?.data?.length ? <ButtonOrLoader buttonIsDisabled={loading} textButton={t('addAddons', 'Añadir complementos')} className='mt-68' /> : null}
            </div>
        </TwinForm>
    )
}

interface ModalCEPATableLogicProps extends ModalComponentProps {
    data: ProductAddonsTableAndSearchDataState
    setData: ProductAddonsTableAndSearchDataStateSetData
    getData?: () => Promise<void>
}

const useModalCEPATableLogic = ({ data, setData, setOpened, onSubmit, getData }: ModalCEPATableLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const deleteRow = useCallback((rowIndex: number) => {
        setData((oldData) => {
            const copy = JSON.parse(JSON.stringify(oldData))
            const deleted = copy.data.splice(rowIndex, 1)
            const ids = []
            if (deleted.length) {
                for (const element of copy.ids) {
                    if (element !== deleted[0].id) {
                        ids.push(element)
                    }
                }
            }
            return ({ ...copy, ids })
        })
    }, [setData])

    const beforeSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading?.()
        if (data) {
            let parseProductAddon: any = []
            for (const key in data.data) {
                parseProductAddon.push(data.data[parseInt(key)].id)
            }
            vals.ProductAddonId = parseProductAddon as any
        }
        return true
    }, [startLoading, data])

    const onSubmitHandler: OnSubmit = useCallback((res, values) => {
        endLoading()
        onSubmit(res, values)
        getData?.()
        setOpened(null)
    }, [onSubmit, setOpened, endLoading, getData])
    
    const changeData: OnChangeSearchBarAddProduct = useCallback((item) => {
        setData((oldData) => {
            const copy = JSON.parse(JSON.stringify(oldData))
            copy.data.push(item)
            copy.ids.push(item.id)
            return copy
        })
    }, [setData])


    return { beforeSubmit, deleteRow, loading, onSubmitHandler, changeData }
}

export default ModalCEPATable